import { useMutation } from "@tanstack/react-query";
import { loggedOutResetPassword } from "@/api/v1-jwt/auth/auth";

export const useLoggedOutResetPassword = () => {
  return useMutation({
    mutationFn: loggedOutResetPassword,
  });
};
